// The Start Counter carry-forward suggestion: its words, and how a page hands
// it to the field.
//
// The RULE -- which types have counters, and what number a prior entry carries
// -- lives in fleet-shared/LogbookTypes.mjs beside deriveEntryFields, which
// already owns the Start/End/Hours relationship. This module is only the
// presentation half, which is why it lives here and not there.

import { displayDate } from '../fleet-shared/Common.mjs';

// The `{ value, label, title }` shape Field renders as a button.
//
// The label carries the NUMBER, not a generic "Copy previous" -- the user is
// being asked to accept a value, and a button that hides it makes them open the
// other entry to check, which is the errand this whole feature removes. The
// title dates the entry it came from, for the same reason: two entries a week
// apart are not interchangeable sources.
//
// `value === 0` is a real counter reading, so this tests for null/undefined
// rather than truthiness -- the same guard carryForwardEndCounter applies at
// the other end.
export function startCounterSuggestion(value, priorEntry) {
  if (value === null || value === undefined) return null;
  const when = priorEntry?.date ? displayDate(priorEntry.date) : null;
  return {
    value,
    label: `Use ${value}`,
    title: when
      ? `End Counter from the previous entry (${when})`
      : 'End Counter from the previous entry',
  };
}

// Clone `fields`, attaching the suggestion to the Start Counter field.
//
// A clone rather than a mutation because the registries are module-level and
// shared by every page in the app -- the same reason withTripSuggestions and
// buildEntryFields clone before injecting. No suggestion means the fields come
// back untouched, so a type without counters, a first entry, and a prior entry
// with no End Counter all render exactly the row they render today.
export function withStartCounterSuggestion(fields, suggestion) {
  if (!suggestion) return fields;
  return (fields || []).map((field) =>
    field.key === 'startCounter' ? { ...field, suggestion } : field
  );
}
